<div class="h-100" *ngIf="web_url">
  <iframe
    class=" h-100"
    [src]="secureUrl"
    allowfullscreen
  ></iframe>
</div>
